export default __webpack_public_path__ + "static/qrcode1-7127246886f512e2e264b995a2f6bb0c.png";